const SPORTS_TV_BASE_URL = "https://diamondtech.shop/streaming/play/sportstv/4";

function getSportsTVUrl(eventId) {
  const streamUrl = new URL(
    `${SPORTS_TV_BASE_URL}/${encodeURIComponent(String(eventId))}`
  );

  streamUrl.searchParams.set("client", "gibbs");
  streamUrl.searchParams.set("embed", "1");
  streamUrl.searchParams.set("ip", "152.56.165.26");

  return streamUrl.toString();
}

export default function SportsTV({ eventId, marketId, sport }) {
  if (!eventId) {
    return null;
  }

  return (
    <iframe
      title={`${sport} live TV`}
      src={getSportsTVUrl(eventId)}
      data-event-id={eventId}
      data-market-id={marketId || undefined}
      style={{
        width: "100%",
        height: "216px",
        marginBottom: -5,
      }}
      allow="autoplay; fullscreen; picture-in-picture"
      allowFullScreen
      referrerPolicy="origin"
    />
  );
}
